// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_1nRxaaMwwnYCs3n_7_iXWF"};